import { graphql, useStaticQuery } from 'gatsby';

export const useStandardFacets = () => {
  const { kfhPropertyFacets } = useStaticQuery(
    graphql`
      query GET_PROPERTY_FACETS {
        kfhPropertyFacets {
          residentialRentalFlatProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialRentalHouseProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialRentalProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialRentalPropertiesLet {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialResaleFlatProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialResaleHouseProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialResaleProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          residentialResalePropertiesSold {
            searchFacets {
              ...SearchFacets
            }
          }
          commercialProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          developmentResaleProperties {
            searchFacets {
              ...SearchFacets
            }
          }
          newHomeProperties {
            searchFacets {
              ...SearchFacets
            }
          }
        }
      }
    `
  );
  return kfhPropertyFacets;
};
